import ReactDOM from 'react-dom';

import '@entsoe/config-webpack/web.config';

import { App } from './containers/App';

// TODO <React.StrictMode>
// https://github.com/ant-design/ant-design/issues/26136
ReactDOM.render(<App />, document.getElementById('root'));
